import md5 from 'blueimp-md5';
import SHA1 from 'jssha/dist/sha1';
import SHA256 from 'jssha/dist/sha256';

const doHashSHA1 = (email: string): string => {
    const shaEmail = new SHA1('SHA-1', 'TEXT');
    shaEmail.update(email);

    return shaEmail.getHash('HEX');
};
const doHashSHA256 = (email: string): string => {
    const shaEmail = new SHA256('SHA-256', 'TEXT');
    shaEmail.update(email);

    return shaEmail.getHash('HEX');
};

const transformers = {
    md5: (email: string) => md5(email.trim().toLowerCase()),
    regionCode: (
        value: string,
        regions: Array<{id: string; label: string; value: string}>,
    ): string => {
        let newValue = '';
        regions.some((region: {label: string; value: string}): boolean => {
            if (region.value === value) {
                newValue = region.value;
                return true;
            }

            if (region.label === value) {
                newValue = region.value;
                return true;
            }

            return false;
        });

        return newValue;
    },
    regionId: (
        value: string,
        regions: Array<{id: string; label: string; value: string}>,
    ): string => {
        const filteredRegions = regions.filter(region => region.value === value);
        return filteredRegions.length > 0 ? filteredRegions[0].id : '';
    },
    sha1: (email: string) => doHashSHA1(email.toLowerCase()),
    sha256: (email: string) => doHashSHA256(email.toLowerCase()),
};

/**
 * This method will transform string using an available transformers
 * @param {string} value Value for transform
 * @param {string} transformerName Name of transformer
 * @param {Array<any>} args Additional arguments
 * @return {string} value Transformed or plain value
 */
export default function doTransform(
    value: string,
    transformerName: keyof typeof transformers | string,
    ...args: Array<any>
): string {
    if (transformers[transformerName as keyof typeof transformers] && value !== '') {
        // @ts-expect-error
        return transformers[transformerName as keyof typeof transformers](value, ...args);
    }
    return value;
}
